import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualConditionMonitoringReq } from "../../../../Redux/Slices/requestManagementSlice";

const ConditionMonitoringRequestDetails = () => {
    const { id } = useParams()
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const [callRequestData, setCallRequestData] = useState({})

    useEffect(() => {
        dispatch(fetchIndividualConditionMonitoringReq({
            data: { id },
            callBack: (value) => {
                console.log(value.data)
                setCallRequestData(value.data)
            }
        }))
    }, [])

    return (
        <MainLayout pageName="Condition Monitoring Requests">
            <div className="goBackDiv" onClick={() => navigate(-1)}>
                <img src={assets.Icons.leftArrow} alt="backIcon" />
                <p>Back to Requests</p>
            </div>
            <div className="CallRequestDetailsContainer">
                {/* Header */}
                <div className="CallRequestDetailsHeader">
                    <h2>Condition Monitoring Request Details</h2>
                </div>
                <hr style={{ backgroundColor: "#E6E6E6" }} />
                <div className="CallDetails">
                    <h3>Request Details</h3>
                    <div>
                        <p className="callDetailLabel">User Name</p>
                        <p className="callDetailLabelData">: {callRequestData?.user_name || '-'}</p>
                    </div>
                    <div>
                        <p className="callDetailLabel">Mobile Number</p>
                        <p className="callDetailLabelData">: {callRequestData?.country_code || '-'}&nbsp;{callRequestData?.mobile_number || '-'}</p>
                    </div>
                    <div>
                        <p className="callDetailLabel">Email ID</p>
                        <p className="callDetailLabelData">: {callRequestData?.email || '-'}</p>
                    </div>
                    <div>
                        <p className="callDetailLabel">Company Name</p>
                        <p className="callDetailLabelData">: {callRequestData?.company_name || '-'}</p>
                    </div>
                    {/* <div>
                     <p className="callDetailLabel">Contact Preference</p>
                     <p className="callDetailLabelData">: {callRequestData.ContactPreference || '-'}</p>
                   </div> */}
                    {/* <div>
                     <p className="callDetailLabel">Reason for Call</p>
                     <p className="callDetailLabelData">: {callRequestData.call_request || '-'}</p>
                   </div> */}
                    <div>
                        <p className="callDetailLabel">Call Date</p>
                        <p className="callDetailLabelData">: {callRequestData?.date ? new Date(callRequestData?.date).toLocaleDateString("en-GB") : '-'}</p>
                    </div>
                    <div>
                        <p className="callDetailLabel">Selected Session</p>
                        <p className="callDetailLabelData">: {callRequestData?.session || '-'}</p>
                    </div>
                    <div>
                        <p className="callDetailLabel">Selected Slot</p>
                        <p className="callDetailLabelData">: {callRequestData?.timing || '-'}</p>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default ConditionMonitoringRequestDetails